"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    CUSTOMER: 'customer',
    COLLEGIAN: 'collegian',
};
//# sourceMappingURL=studentContractStatus.js.map